import React from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

const PrivacySection = ({ title, description }: { title: string; description: string }) => {
  return (
    <Box>
      <Typography
        variant={'h6'}
        gutterBottom
        sx={{
          fontWeight: 'medium',
        }}
      >
        {title}
      </Typography>
      <Typography component={'p'} color={'textSecondary'}>
        {description}
      </Typography>
    </Box>
  );
};

PrivacySection.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
};

const Content = () => {
  const data = [
    {
      title: '',
      description:
        'Настоящий Договор на участие в торгово- операционной системе Электронная торговая площадка является публичным Договором (далее – Договор), а приведенные ниже в нем условия являются офертой (предложением) Товарищества с ограниченной ответственностью « Электронная торговая площадка », именуемого в дальнейшем «Оператор», в лице Генерального директора _____., действующей на основании Устава, к любому юридическому лицу или физическому лицу, осуществляющему индивидуальное предпринимательство, именуемому в дальнейшем «Участник Системы», которое акцептует (принимает) эти условия Договора.',
    },
    {
      title: '',
      description:
        'Настоящая оферта Оператора считается акцептованной Участником Системы, а Договор считается заключенным на нижеприведенных условиях, если Участник Системы осуществил один из следующих вариантов конклюдентных действий:',
    },
    {
      title: '',
      description:
        '1.	осуществил свою регистрацию в Системе Оператора, расположенной на сайте Оператора - https://fincom.kz, и предоставил ему подписной лист, подтверждающий его присоединение к Договору.',
    },
    {
      title: '',
      description:
        '2.	осуществил свою регистрацию в Системе Оператора, расположенной на сайте Оператора - https://fincom.kz, и произвел платеж в счет оплаты абонентского обслуживаний. ',
    },
    {
      title: '',
      description:
        '3.	осуществил свою регистрацию в Системе Оператора и присоединение к Регламенту работы электронной торговой площадки Электронная торговая площадка в порядке, установленном на сайте Оператора - https://Электронная торговая площадка.kz.',
    },
    {
      title: '1. ОСНОВНЫЕ ТЕРМИНЫ И ОПРЕДЕЛЕНИЯ',
      description:
        '1.1. Система – совокупность технических и организационных средств Оператора, включая программно-аппаратные комплексы, обеспечивающая оптимизацию взаимодействия предприятий с партнерами и контрагентами, и размещенная во всемирной компьютерной сети Интернет по адресу: https://Электронная торговая площадка.kz.',
    },
    {
      title: '',
      description:
        '1.2. Оператор Системы – ТОО Электронная торговая площадка',
    },
    {
      title: '',
      description:
        '1.3. Участник Системы – любое юридическое лицо или физическое лицо, осуществляющее индивидуальное предпринимательство, прошедшее процедуру регистрации в Системе и имеющее право использования функций Системы в соответствии с уровнем доступа.',
    },
    {
      title: '',
      description:
        '1.4. Регистрация - действие, в результате которого юридическое или физическое лицо, в том числе, индивидуальный предприниматель, получает уникальный номер Участника Системы, включается в базы данных Системы и получает уникальные аутентификационные данные для входа в Закрытую часть Системы.',
    },
    {
      title: '',
      description:
        '1.5. Регламент Системы/Регламент - Регламент работы электронной торговой площадки Электронная торговая площадка, являющийся приложением 1 к Договору, и Отдельный регламент работы электронной торговой площадки Электронная торговая площадка для субъектов естественных монополий, являющийся приложением 2 к Договору.',
    },
    {
      title: '',
      description:
        '1.6. Личный кабинет – элемент Закрытой части Системы, автоматизированное рабочее место Пользователя.',
    },
    {
      title: '',
      description:
        '1.9. Электронная торговая площадка Системы/ЭТП – программно-аппаратный комплекс, являющийся составной частью Системы и предназначенный для проведения в электронной форме закупки и/или продажи по упорядоченной формализованной процедуре, урегулированной Регламентом Системы. Регламент Системы обеспечивает проведение в электронной форме процесса закупок в соответствии с требованиями Правил',
    },
    {
      title: '',
      description:
        '1.10. Торги – закупки, аукционы, а также иные Процедуры, если последние прямо поименованы в качестве таковых действующим законодательством Республики Казахстан.',
    },
    {
      title: '',
      description:
        '1.11. Позиции/ТРУ – товары, работы, услуги.',
    },
    {
      title: '',
      description:
        '1.12. Процедура – последовательность действий, осуществляемая Организатором в соответствии с установленными им правилами и Регламентом Системы, в результате которой осуществляется выбор Поставщика (Покупателя) или формируется перечень Поставщиков (Покупателей) для последующей покупки (продажи).',
    },
    {
      title: '',
      description:
        '1.13. Организатор процедуры/Организатор - Заказчик или организация, непосредственно выполняющие действия, предусмотренные той или иной Процедурой.',
    },
    {
      title: '',
      description:
        '1.14. Поставщик – любое юридическое или физическое лицо, в том числе индивидуальный предпринимать, способное на законных основаниях поставить требуемую Продукцию. ',
    },
    {
      title: '',
      description:
        '1.15. Потенциальный поставщик по закупкам субъектов естественных монополий - физическое лицо, осуществляющее предпринимательскую деятельность, юридическое лицо (за исключением государственных учреждений, если иное не установлено для них законами Республики Казахстан), временное объединение юридических лиц (консорциум), претендующие на заключение договора о закупках, способное на законных основаниях',
    },
    {
      title: '',
      description:
        '1.16. Дополнительный пользователь – Пользователь, наделённый полномочиями по совершению действий в соответствии с предоставленными ему правами, за исключением возможности публикации Процедуры и отправки, редактирования и отзыва Заявки Участника Системы по Процедуре, подачи заявки на возврат денежных средств для их вывода со счета Участника Системы.',
    },
    {
      title: '2. ПРЕДМЕТ ДОГОВОРА',
      description:
        '2.1. В соответствии с настоящим Договором Оператор на основе утвержденных им Тарифов, размещенных в сети Интернет по адресу: https://Электронная торговая площадка.kz, и являющихся приложением 3 к Договору (далее – Тарифы), оказывает Участнику Системы комплекс услуг по его участию в базах данных и Процедурах в Системе (далее - услуги) согласно утвержденному им Регламенту работы электронной торговой площадки Электронная торговая площадка, являющемуся приложением 1 к Договору, и Отдельному регламенту работы электронной торговой площадки Электронная торговая площадка для субъектов естественных монополий, являющемуся приложением 2 к Договору, обеспечивающих: 2.1.1. Размещение в базах данных Системы информации, предоставленной самим Участником Системы.',
    },
    {
      title: '',
      description:
        '2.1.2. Доступ к информации, размещенной другими Участниками Системы в базах данных Системы.',
    },
    {
      title: '',
      description:
        '2.1.3. Возможность работы Участника Системы в Личном кабинете на ЭТП, в том числе с правом организации Процедур и участия в Процедурах, организуемых другими Участниками Системы, в зависимости от полученного уровня доступа к Системе, а также во всех других разделах Системы, в соответствии с Договором, Регламентом и другими нормативными документами Оператора, обязательными к выполнению Участниками Системы.',
    },
    {
      title: '',
      description:
        '2.1.4. Предоставление Участнику Системы дополнительного Личного кабинета для повышения удобства работы Участника Системы в Системе.',
    },
    {
      title: '',
      description:
        '2.1.5. Возможность Участника Системы работать во всех других разделах Системы, которые появились в Системе после подписания настоящего Договора, и за работу в которых Участником Системы была своевременно произведена соответствующая оплата.',
    },
    {
      title: '',
      description:
        '2.1.6. Удаленную консультационную поддержку Участника Системы.',
    },
    {
      title: '',
      description:
        '2.2. Оператор начинает оказание комплекса услуг после подписания Сторонами настоящего Договора либо после того, как Участник Системы произведет авансовую оплату в случае, если такая оплата предусмотрена Тарифами.',
    },
    {
      title: '',
      description:
        '2.3. Отношения Оператора и Участника Системы регламентируются внутренними нормативными документами Оператора, настоящим Договором и его приложениями.',
    },
    {
      title: '3. ПРАВА СТОРОН',
      description:
        '3.1. Оператор вправе проверять информацию, предоставляемую Участником Системы.',
    },
    {
      title: '',
      description:
        '3.2. Права на Базы данных принадлежат исключительно Оператору Системы.',
    },
    {
      title: '',
      description:
        '3.3. Оператор вправе в одностороннем порядке вносить изменения и дополнения в Договор и его приложения, а также в другие нормативные документы, обязательные к выполнению Участниками Системы.',
    },
    {
      title: '',
      description:
        '3.4. В случае задержки оплаты услуг Участником Системы, Оператор вправе приостановить либо ограничить ему доступ к Системе.',
    },
    {
      title: '',
      description:
        '3.5. Оператор вправе отключить Участника Системы от работы в Системы в одностороннем порядке в случаях, предусмотренных Регламентом работы электронной торговой площадки Электронная торговая площадка.',
    },
    {
      title: '',
      description:
        '3.6. Участник Системы вправе размещать информацию о себе в Базах данных Системы в качестве продавца/поставщика и(или) покупателя/заказчика ТРУ.',
    },
    {
      title: '',
      description:
        '3.7. Участник Системы вправе самостоятельно организовывать и проводить Торги на Торговой площадке Системы согласно полученному им уровню доступа к Системе.',
    },
    {
      title: '',
      description:
        '3.8. Участник Системывправе принимать участие в Торгах, организуемых другими Участниками Системы, согласно полученному им уровню доступа к Системе.',
    },
    {
      title: '',
      description:
        '3.9. Участник Системывправе изменять информацию о предоставляемых и(или) потребляемых им ТРУ.',
    },
    {
      title: '',
      description:
        '3.10. Участник Системы не вправе приостановить свое участие в Системе в течение оплаченного периода.',
    },
    {
      title: '',
      description:
        '3.11. Стороны обладают также иными правами, предусмотренными нормативными документами Оператора.',
    },
    {
      title: '4. ОБЯЗАННОСТИ СТОРОН',
      description:
        '4.1. Оператор обязуется:',
    },
    {
      title: '',
      description:
        '4.1.1. Подключить Участника Системы к Системе не позднее 3-х рабочих дней после представления им Подписного листа  и всех необходимых подтверждающих документов и  поступления денежных средств на расчетный счет Оператора, если для запрошенного Участником Системы уровня доступа предусмотрена оплата абонентской платы.',
    },
    {
      title: '',
      description:
        '4.1.2. Обеспечить Участнику Системы возможность доступа к Личному кабинету в Системе и информационным базам данных Оператора, а также возможность размещения информации Участником Системы в базах данных Системы в качестве продавца (поставщика) и покупателя (заказчика) Продукции (ТРУ), с учетом полученного им уровня доступа к Системе.',
    },
    {
      title: '',
      description:
        '4.1.3. Обеспечить возможность для Участника Системы самостоятельно организовывать и проводить Процедуры в Системе и принимать участие в Процедурах, организуемых другими Участниками Системы, с учетом полученного им уровня доступа к Системе.',
    },
    {
      title: '',
      description:
        '4.1.4. Обеспечить Участнику Системы возможность доступа ко всем другим разделам Системы, которые появились в Системе после подписания настоящего Договора и, за работу в которых, Участником Системы была своевременно произведена соответствующая оплата.',
    },
    {
      title: '',
      description:
        '4.1.5. Предоставить Участнику Системы по письменному заявлению, оформленному надлежащим образом и направленному в адрес Оператора, дополнительный (второй, третий и более) Личный кабинет для работы Участника Системы в Системе.',
    },
    {
      title: '',
      description:
        '4.1.6. Обеспечить удаленную консультационную поддержку по размещению самим Участником Системы информации в базах данных Системы по телефонам справочной службы и службы поддержки он-лайн, размещенных на сайте: https://Электронная торговая площадка.kz.',
    },
    {
      title: '',
      description:
        '4.1.7. Уведомлять Участников Системы о вносимых изменениях и дополнениях в Договор и его приложения, а также в другие нормативные документы Оператора, обязательные к выполнению Участниками Системы, путем опубликования данных изменений и дополнений на сайте по адресу: https://Электронная торговая площадка.kz., за 10 календарных дней до их вступления в силу.',
    },
    {
      title: '',
      description:
        '4.2. Участник Системы обязуется:',
    },
    {
      title: '',
      description:
        '4.2.1. Для включения в базы данных Системы заполнить заявку на регистрацию в электронном виде на сайте по адресу: https://Электронная торговая площадка.kz.',
    },
    {
      title: '',
      description:
        '4.2.2. Оплатить тариф с учетом выбранного им уровня доступа в Систему.',
    },
    {
      title: '',
      description:
        '4.2.3. Работать в Системе, соблюдая все требования настоящего Договора, его приложений, а также других нормативных документов Оператора, обязательных к выполнению Участниками Системы, расположенными на сайте по адресу: https://Электронная торговая площадка.kz.',
    },
    {
      title: '',
      description:
        '4.2.4. Своевременно обновлять информацию о предлагаемых и (или) потребляемых продуктах и оказываемых услугах в Системе.',
    },
    {
      title: '',
      description:
        '4.2.5. Извещать Оператора в письменной форме о необходимости внесения изменений в реквизиты, размещенных им в Системе, в течение 5 (пяти) календарных дней с момента изменения соответствующих реквизитов.',
    },
    {
      title: '',
      description:
        '4.2.6. Своевременно оплачивать услуги Оператора в соответствии с условиями настоящего Договора и Тарифами.',
    },
    {
      title: '',
      description:
        '4.3. Участник Системы, при подаче заявки в Систему Оператора на участие в Процедуре принимает все условия данной Процедуры, действующих по ней тарифов и предусмотренных размеров гарантийного обеспечения Оператору Системы.',
    },
    {
      title: '',
      description:
        '4.4. Стороны несут также иные обязанности, предусмотренные нормативными документами Оператора.',
    },
    {
      title: '5. ПОРЯДОК РАСЧЕТОВ',
      description:
        '5.1. Размер и порядок оплаты услуг Оператора по настоящему Договору определены Тарифами.',
    },
    {
      title: '',
      description:
        '5.2. Оператор предоставляет Участнику Системы, заявившему/получившему полноправный доступ к Системе, возможность работать в своем Личном кабинете в Системе только после того, как Участник Системы оплатит абонентскую плату Оператору и внесет денежное обеспечение согласно Тарифам.',
    },
    {
      title: '',
      description:
        '5.3. Для повышения удобства работы Участника Системы в Системе Оператор предоставляет (организует) Участнику Системы дополнительный (второй, третий и более) Личный кабинет для работы Участника Системы в Системе. Все дополнительные Личные кабинеты для работы в Системе Оператор предоставляет (организует) Участнику Системы без дополнительной оплаты.',
    },
    {
      title: '',
      description:
        '5.4. Порядок предоставления Актов об оказании услуг и налоговых счетов-фактур определены Регламентом.',
    },
    {
      title: '',
      description:
        '5.5. В случае расторжения настоящего Договора по инициативе Участника Системы до истечения оплаченных авансом дней/месяцев работы в Системе, Оператор не возвращает Участнику Системы абонентскую плату за неиспользованный период.',
    },
    {
      title: '6. ОТВЕТСТВЕННОСТЬ СТОРОН',
      description:
        '6.1. В случае неисполнения или ненадлежащего исполнения настоящего Договора Стороны несут ответственность, предусмотренную действующим законодательством Республики Казахстан.',
    },
    {
      title: '',
      description:
        '6.2. В случае несвоевременной/не полной оплаты Участником Системы услуг Оператора, Участник Системы оплачивает Оператору пеню (неустойку) в размере 0,1 % (одной десятой процента) от несвоевременно оплаченной суммы денег за каждый календарный день задержки оплаты услуг Оператора. Оплата Участником Системы Оператору неустойки не освобождает Участника Системы от оплаты услуг Оператора.',
    },
    {
      title: '',
      description:
        '6.3. Ответственность за достоверность информации об Участнике Системы, предлагаемых (и/или потребляемых) им продуктах и услугах, несет сам Участник Системы, разместивший информацию в Системе.',
    },
    {
      title: '',
      description:
        '6.4. Оператор не несет ответственности за какой-либо ущерб, потери и прочие убытки, которые понес Участник Системы по причине наличия у Участника Системы несоответствующего аппаратно-технического комплекса, необходимого для работы в Системе, как то:',
    },
    {
      title: '',
      description:
        '6.4.1. Отсутствие у Участника Системы компьютерной техники с необходимым набором программно-технических возможностей, удовлетворяющих требованиям для работы в Системе, изложенным в разделе Требования к компьютеру по адресу: https://Электронная торговая площадка.kz.',
    },
    {
      title: '',
      description:
        '6.4.2. Наличие программно-технических ограничений и настроек, которые содержались в компьютерной технике Участника Системы, что не позволило Участнику Системы полноценно работать в Системе;',
    },
    {
      title: '',
      description:
        '6.4.3. Невозможность работы Участника Системы в Системе по причине заражения компьютерной техники вирусами;',
    },
    {
      title: '',
      description:
        '6.4.4. Недостатки в работе сетевых систем и ограничения, введенные отделом автоматизированной системы управления на предприятии Участника Системы, а также сбои в работе аппаратно-технического комплекса отдела автоматизированной системы управления на предприятии Участника Системы, что привело к нерегламентированным и непредвиденным временным отключениям Участника Системы от всемирной компьютерной сети Интернет и не позволило Участнику Системы полноценно работать в Системе;',
    },
    {
      title: '',
      description:
        '6.4.5. Недостатки в работе сетевых систем и ограничения, введенные региональным провайдером (компанией, предоставляющей Участнику доступ во всемирную компьютерную сеть Интернет) на предприятии Участника Системы, а также сбои в работе аппаратно-технического комплекса у регионального провайдера Участника Системы, что привело к нерегламентированным и непредвиденным временным отключениям Участника Системы от всемирной сети Интернет и не позволило Участнику полноценно работать в Системе.',
    },
    {
      title: '',
      description:
        '6.5. Оператор не несет ответственности за какой-либо ущерб, потери и прочие убытки, которые понес Участник Системы по причине ненадлежащего соблюдения требований, касающихся работы Участника Системы в Системе и отношений Оператора и Участника Системы, как то:',
    },
    {
      title: '',
      description:
        '6.5.1. Незнание сотрудниками Участника Системы Договора, Регламента, других нормативных документов Оператора (что входит в обязанности Участника Системы), невыполнение или ненадлежащее выполнение сотрудниками Участника Системы прописанных в них требований и процедур, что привело к принятию Участником Системы на себя дополнительных, излишних, повышенных и незапланированных обязательств перед другими Участниками Системы и негативно сказалось на коммерческой активности и деловой репутации Участника Системы в Системе;',
    },
    {
      title: '',
      description:
        '6.5.2. Несоблюдение правил хранения логина (имени) и пароля или несанкционированная руководством Участника Системы передача сотрудником, назначенным в качестве лица, ответственного за работу Участника Системы в Системе, логина (имени) и пароля для входа и работы в Системе третьим лицам, не имеющим соответствующих полномочий и квалификации на работу в Системе;',
    },
    {
      title: '',
      description:
        '6.5.3. Действия, совершенные в Системе от имени Участника Системы третьими лицами из-за их некомпетентности и незнания ими Договора, Регламента, других нормативных документов Оператора (что входит в обязанности Участника Системы), которые привели к принятию Участником Системы на себя дополнительных, излишних, повышенных и незапланированных обязательств перед другими Участниками Системы;',
    },
    {
      title: '',
      description:
        '6.5.4. Действия, совершенные в Системе от имени Участника Системы третьими лицами, повлекшими за собой изменение информации о самом Участнике Системы, что негативно сказалось на его коммерческой активности и деловой репутации как Участника Системы.',
    },
    {
      title: '',
      description:
        '6.6. Оператор не несет ответственности перед Участником Системы в случае, если информация, размещенная Участником Системы в базе данных Системы, по вине самого Участника Системы (сотрудников предприятия Участника Системы) станет известна третьим лицам, которые использовали ее с целью нанести ущерб предприятию Участника Системы.',
    },
    {
      title: '7. ФОРС-МАЖОР',
      description:
        '7.1. Стороны освобождаются от ответственности за частичное или полное неисполнение обязательств по настоящему Договору, если это неисполнение явилось следствием обстоятельств непреодолимой силы, таких как: наводнение, пожар, землетрясение и другие природные катаклизмы, а также военные действия, блокада, запретительные действия властей и акты государственных органов, разрушение коммуникаций и энергоснабжения, взрывы, возникших после заключения настоящего Договора, которые Стороны не могли предвидеть или предотвратить разумными способами и средствами.',
    },
    {
      title: '',
      description:
        '7.2. При наступлении обстоятельств, указанных в первом пункте настоящего раздела, каждая Сторона должна без промедления письменно известить о них другую Сторону. Извещение должно содержать данные о характере обстоятельств, а также официальные документы, удостоверяющие наличие этих обстоятельств и, по возможности, дающие оценку их влиянию на возможность исполнения Стороной своих обязательств по данному Договору.',
    },
    {
      title: '',
      description:
        '7.3. Если Сторона не направит или несвоевременно направит извещение, то она обязана возместить второй Стороне понесенные убытки.',
    },
    {
      title: '',
      description:
        '7.4. Если наступившие обстоятельства, указанные в настоящем разделе, и их последствия продолжают действовать более двух месяцев, Стороны проводят дополнительные переговоры для выявления приемлемых альтернативных способов исполнения настоящего Договора.',
    },
    {
      title: '8. КОНФИДЕНЦИАЛЬНОСТЬ',
      description:
        '8.1. Каждая из Сторон в рамках отношений по настоящему Договору обязуется сохранять строгую конфиденциальность получения от другой Стороны технологической,финансовой, коммерческой и другой информации, полученной или ставшей им известной при исполнении настоящего Договора, и примет все возможные меры, чтобы предохранить полученную конфиденциальную информацию от разглашения.',
    },
    {
      title: '',
      description:
        '8.2. Передача конфиденциальной информации третьим лицам, опубликование или иное разглашение такой информации, в том числе в течение трех лет после прекращения настоящего Договора, может осуществляться только с согласия другой Стороны, независимо от причин прекращения настоящего Договора.',
    },
    {
      title: '',
      description:
        '8.3. В случае разглашения одной из Сторон третьим лицам конфиденциальной информации, а также информации относящейся к коммерческой тайне контрагента, виновная Сторона обязана возместить другой Стороне понесенные последней убытки.',
    },
    {
      title: '',
      description:
        '8.4. Не является конфиденциальной информацией информация, размещенная Участником Системы в Системе, право доступа к которой предоставлено неограниченному кругу лиц. Ответственность за содержание информации в Системе лежит на Участнике Системы, как на лице, разместившим данную информацию.',
    },
    {
      title: '9. СРОК ДЕЙСТВИЯ ДОГОВОРА. УСЛОВИЯ И ПОРЯДОК РАСТОРЖЕНИЯ ДОГОВОРА',
      description:
        '9.2. Настоящий Договор вступает в силу с даты совершения Участником Системы второго действия предусмотренного по каждому варианту конклюдентных действий, подтверждающих присоединение Участника Системы к Договору (представления подписного листа/осуществления платежа в счет оплаты абонентского обслуживания), но не ранее даты официального запуска работы ЭТП, опубликованной на сайте по адресу https://Электронная торговая площадка.kz.Договор действует до окончания текущего календарного года.',
    },
    {
      title: '',
      description:
        '9.3. Срок действия Договора автоматически продлевается (пролонгируется) на следующий календарный год, если ни одна из Сторон не заявила о его прекращении не менее чем за 30 (тридцать) календарных дней до окончания календарного года в письменном виде, если иное не предусмотрено настоящим Договором.',
    },
    {
      title: '',
      description:
        '9.4. Количество последующих пролонгаций Договора не ограничено.',
    },
    {
      title: '',
      description:
        '9.5. Стороны имеют право в любое время расторгнуть настоящий Договор в одностороннем внесудебном порядке путем письменного уведомления другой Стороны не позднее, чем за 30 (тридцать) календарных дней до планируемой даты расторжения настоящего Договора, если иное не предусмотрено настоящим Договором.',
    },
    {
      title: '',
      description:
        '9.6. Настоящий Договор автоматически прекращает свое действие или расторгается Оператором в одностороннем порядке в описанных ниже случаях:',
    },
    {
      title: '',
      description:
        '9.6.1. в случае не оплаты/не своевременной оплаты услуг Участником Системы, Оператор вправе незамедлительно расторгнуть Договор без каких-либо возмещений Участнику Системы (остаток денежных средств, находящихся на Счете Участника Системы принимается в качестве штрафной зачетной неустойки). Расторжение Договора по указанным причинам производится Оператором в одностороннем порядке путем направления соответствующего уведомления Участнику Системы посредством электронной почты на адреса Участника Системы;',
    },
    {
      title: '',
      description:
        '9.6.2. по причине нарушения Участником Системы пунктов настоящего Договора, не связанных с неоплатой Участником Системы услуг, включая требования о неразглашении конфиденциальной информации, а также при нарушении им требований настоящего Договора, его приложений, других нормативных документов Оператора, обязательных к выполнению Участниками Системы, размещенных на сайте https://Электронная торговая площадка.kz. Расторжение Договора по указанным причинам производится Оператором в одностороннем порядке путем направления соответствующего уведомления Участнику Системы посредством электронной почты на адреса УчастникаСистемы;',
    },
    {
      title: '',
      description:
        '9.7. Оператор вправе расторгнуть настоящий Договор в одностороннем порядке в иных случаях, предусмотренных Договором, а также действующим законодательством Республики Казахстан.',
    },
    {
      title: '',
      description:
        '9.8. Оператор вправе в одностороннем порядке изменять условия настоящего Договора и приложений к нему. О вводимых изменениях Оператор извещает Участника системы путем опубликования сообщения об изменениях, самих изменений и/или новых документов на Сайте Оператора.',
    },
    {
      title: '',
      description:
        '9.9. Если Участник Системы не согласен с вводимыми изменениями, он вправе незамедлительно расторгнуть настоящий Договор, уведомив об этом Оператора в письменном виде. В случае отсутствия у Оператора письменного уведомления от Участника Системы о расторжении Договора по указанным причинам в течение 5 (пяти) календарных дней с момента вступления изменений в силу, указанные изменения считаются принятыми Участником Системы. При этом Участник Системы вправе расторгнуть настоящий Договор и отказаться от Услуг Оператора, только при условии возмещения последнему фактически понесенных им расходов до момента расторжения.',
    },
    {
      title: '',
      description:
        '9.10. В случае досрочного расторжения Договора Участнику Системы по его письменному заявлению со Счета Участника Системы производится возврат неиспользованных денежных средств, кроме случаев, предусмотренных настоящим Договором и приложениями к нему. При этом возврат средств производится только в безналичном порядке. Перечисление возвращаемых средств третьему лицу по просьбе Участника Системы не производится.',
    },
    {
      title: '',
      description:
        '9.11. После расторжения настоящего Договора, заключение нового аналогичного Договора может быть осуществлено на общих условиях.',
    },
    {
      title: '10. РАЗРЕШЕНИЕ СПОРОВ',
      description:
        '10.1. Для разрешения споров по настоящему Договору применяется обязательный претензионный порядок со сроком ответа на претензию — 15 (пятнадцать) рабочих дней с момента ее получения. В случае не достижения согласия такие споры рассматриваются в судебном порядке в судах Республики Казахстан.',
    }
  ];
  return (
    <Box>
      {data.map((item, i) => (
        <Box key={i} marginBottom={i < data.length - 1 ? 4 : 0}>
          <PrivacySection {...item} />
        </Box>
      ))}
    </Box>
  );
};

export default Content;
